<div #tabElem class="business-navbar__tab">
  {{ label }}
</div>
